// extracted by mini-css-extract-plugin
export default {"restrictedAccess":"modalStartChat_restrictedAccess__gC7rE","restrictedIcon":"modalStartChat_restrictedIcon__VcMzY","restrictedContent":"modalStartChat_restrictedContent__92Kau"};